"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Sentry = __importStar(require("@sentry/browser"));
var react_1 = __importDefault(require("react"));
/** https://www.smashingmagazine.com/2020/06/react-error-handling-reporting-error-boundary-sentry/ */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            eventId: undefined,
            errorInfo: undefined,
            hasError: false,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error({ error: error, errorInfo: errorInfo });
        // We init Sentry here because we only want to use Sentry here. We don't want a ton of errors from all kinds of third party scripts on our site.
        // We want only the errors thrown by this V2 Bundler.
        Sentry.init({
            dsn: 'https://2d3b5a04486d41cfa498190c6c8553c2@o226612.ingest.sentry.io/1379925',
            environment: window.location.href.match(/localhost/) ? 'dev' : 'prod',
            release: 'hb-theme@' + new Date().valueOf(),
        });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        var eventId = Sentry.captureException(error, { extra: errorInfo });
        this.setState(__assign(__assign({}, this.state), { eventId: eventId, errorInfo: errorInfo }));
    };
    ErrorBoundary.prototype.render = function () {
        var _this = this;
        if (this.state.hasError) {
            return (react_1.default.createElement("div", { className: 'padding-horizontal-6 width-100 height-100 bg-white' },
                react_1.default.createElement("div", { className: 'h-8' }),
                react_1.default.createElement("div", { className: 'margin-horizontal-auto', style: { maxWidth: 640 } },
                    react_1.default.createElement("div", { className: 'text-xl' }, "Oops! We got a little carried away and broke something."),
                    react_1.default.createElement("div", { className: 'h-8' }),
                    react_1.default.createElement("div", { className: 'bg-white width-100 width-100 h-16 flex-container align-justify align-bottom' },
                        react_1.default.createElement("div", { className: 'padding-vertical-2 padding-horizontal-3 flex-container align-center align-middle rounded-base border-wisteria bg-wisteria text-base text-white cursor-pointer', style: { borderWidth: 1, borderStyle: 'solid' }, onClick: function () {
                                window.location.reload();
                            } }, "Reload page"),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: 'text-center text-sm text-gray' }, "Want to help us fix this?"),
                            react_1.default.createElement("div", { className: 'padding-vertical-2 padding-horizontal-3 flex-container align-center align-middle rounded-base border-wisteria text-base text-wisteria cursor-pointer', style: { borderWidth: 1, borderStyle: 'solid' }, onClick: function () { return Sentry.showReportDialog({ eventId: _this.state.eventId }); } }, "Report feedback!"))))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.default.Component));
exports.default = ErrorBoundary;
